<template>
  <v-row>

    <v-col
      v-if="search"
      cols="12"
      class="mb-2"
    >
      <v-text-field
        v-model="searchValue"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getDataFromApi()"
        @keydown="checkKeypress"
      />
    </v-col>

    <v-col cols="12" style="position: relative;">
      
      <v-card>

        <v-data-table
          :headers="headers"
          :items="households"
          :options.sync="options"
          :server-items-length="totalHouseholds"
          :loading="loading"
          :footer-props="tableFooterProps"
          @click:row="householdClicked"
        >
          <template v-slot:[`item.user.full_name`]="{ item }">
            <v-row no-gutters class="flex-nowrap align-center">
              <v-col class="flex-shrink-1 flex-grow-0 mr-2">
                <v-icon x-large>mdi-home</v-icon>
              </v-col>
              <v-col>
                <v-row no-gutters class="flex-column">
                  <v-col class="title">{{ item.user.full_name }}</v-col>
                  <v-col v-if="item.spouse">{{ item.spouse.full_name }}</v-col>
                </v-row>
              </v-col>
              <v-col v-if="!all" class="flex-shrink-1 flex-grow-0 ml-2 title">
                ${{ householdTotalIncome(item) }}
              </v-col>
            </v-row>
          </template>

          <template v-slot:[`item.user.agent.full_name`]="{ item }">
            <div>
              <v-icon x-small class="mr-1">mdi-account-tie</v-icon>
              <span>{{ item.user.agent.full_name }}</span>  
            </div>
            <div>
              <span v-if="item.user.agent.partnership">
                <v-icon x-small class="mr-1">mdi-handshake</v-icon>
                {{ item.user.agent.partnership.name }}
              </span>
              <span v-else class="grey--text text--lighten-1">
                <v-icon x-small class="mr-1 grey--text text--lighten-1">mdi-handshake</v-icon>
                None
              </span>
            </div>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ $moment.unix(item.created_at).calendar() }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'HouseholdBrowser',
  props: {
    householdList: {
      type: Array,
      default: null
    },
    search: Boolean,
    all: Boolean
  },
  data: () => ({
    loading: true,
    searchValue: null,
    households: [],
    totalHouseholds: 0,
    options: {},
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  mounted() {
    //this.getDataFromApi()
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  computed: {
    headers () {
      let hd = []
      hd.push({
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      })
      hd.push({
        text: 'Name',
        align: 'start',
        value: 'user.full_name',
      })

      if(this.all) {
        hd.push({
          text: 'Agent',
          align: 'start',
          value: 'user.agent.full_name'
        })
      }

      hd.push({
        text: 'Created',
        align: 'start',
        value: 'created_at',
        width: '200px'
      })
      return hd
    }
  },
  methods: {
    getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let qParams = []

      this.loading = true
      if(this.all) {
        qParams.push('expand=user,spouse,user.agent,user.agent.partnership')
      } else {
        qParams.push('expand=user,spouse')
      }
      qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0])
      qParams.push('per-page=' + itemsPerPage)
      qParams.push('page=' + page)
      qParams.push('f[active]=1')
      if(!this.all) qParams.push('f[user.agent_id]=' + this.$root.currentUser.id)
      if(this.searchValue) qParams.push('s=' + encodeURIComponent(this.searchValue))

      if(this.householdList) qParams.push('f[id][in]=' + this.householdList.join(','))


      this.$http.get('households?' + qParams.join('&'))
        .then(response => {
          this.households = response.data.items
          this.totalHouseholds = response.data._meta.totalCount
        })
        .catch(err => {
          if(err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading households', 'error')
        })
        .finally(() => {
          this.loading = false
        })

    },
    householdClicked(household) {
      this.$router.push({name: 'households-view', params:{household_id: household.id}})
    },
    householdTotalIncome(household) {
      let monthly = parseInt(household.user_income_monthly || 0)
      let additional = parseInt(household.income_additional || 0)
      let spouse = parseInt(household.spouse_income_monthly || 0)
      return monthly + additional + spouse
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getDataFromApi()
    }
  }
}
</script>